export const ARROW_POSITIONS = ['top', 'bottom', 'left', 'right', 'none'] as const;
export type ArrowPosition = (typeof ARROW_POSITIONS)[number];
